import React, {useEffect, useState} from 'react';
import NavBar from '../components/NavBar';
import SideBar from '../components/sidebar/SideBar';
import {isBrowser, isMobile} from 'react-device-detect';
import NavBarMobile from "../components/NavBarMobile";
import {useDispatch, useSelector} from "react-redux";
import {getVendorType} from "../services/auth";
import {getMenuList} from "../utils/utils";
import MessagesList from "../pages/dashboard/components/messages/MessagesList";
import PharmacyBottomNavigation from "../components/PharmacyBottomNavigation";
import LOGO from "../assets/images/snapdc_logo.png";
import {useHistory} from "react-router-dom";

const AdminLayout = (props) => {
    const dispatch = useDispatch();
    let history = useHistory();

    const {children} = props;
    const {toggle_sidebar_state} = useSelector(state => state.general);
    const {
        get_vendor_messages_success
    } = useSelector((state) => state.messages);
    const [messages, setMessages] = useState([]);
    const [activeRoute,setActiveRoute] = useState(history.location.pathname)
    const vendor_type = getVendorType();
    const {
        pharmacy_orders_success
    } = useSelector((state) => state.dashboard);



    useEffect(() => {
        if (get_vendor_messages_success.result !== undefined && get_vendor_messages_success.result === 'SUCCESS') {
            setMessages(get_vendor_messages_success.data.messages);
        }
    }, [get_vendor_messages_success, pharmacy_orders_success]);
    const isActive = (item) => {
        return activeRoute === item.path
    }
    const updateRoute = (item) => {
        setActiveRoute(item.path)
    }
    if (isBrowser) {
        return (
            <>
                <div className="wrapper">
                    <div className="div">
                        <div className="sidebar-holder bg-white shadow-sm">
                            <SideBar history={history}/>
                            <NavBar/>
                        </div>
                        <div className="container-fluid">
                            <div className="pages-wrapper">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    } else if (isMobile) {
        return (
            <>
                <div className="wrapper-mobile">
                    <div className="div">
                        <NavBarMobile/>
                        <div
                            className={"sidebar-holder-mobile " + (toggle_sidebar_state === true ? "sidebar-holder-mobile-open " : " ") + "bg-white shadow-sm"}>
                            <div className="menu-holder">
                                <div className="messages-list-holder-mobile">
                                    {messages.length > 0 ? <MessagesList messages={messages}/> : null}
                                </div>
                                <div className="logo-holder">
                                    <img src={LOGO} alt="" width={110}/>
                                </div>
                                {
                                    getMenuList(vendor_type).map((menu, index) => {
                                        return (
                                            <div key={index} className={"menu-item-parent " + (isActive(menu) ? "active" : "")}>
                                                <a className="menu-title" href={menu.path} onClick={() => updateRoute(menu)}>
                                                    {
                                                        menu.title
                                                    }
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="pages-wrapper-mobile">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
export default AdminLayout;